/**
 * Resolve study route name for current tab context.
 * courses → StudyCourse; master-classes → MasterClassStudyCourse; favorites → FavoritesStudyCourse
 */
export function studyRouteName(baseName, route) {
  const prefix = route?.meta?.studyContextPrefix || ''
  return prefix ? `${prefix}${baseName}` : baseName
}

export function getStudyCourseEntryName(navigationTabOrPrefix) {
  if (navigationTabOrPrefix === 'master-classes' || navigationTabOrPrefix === 'MasterClass') {
    return 'MasterClassStudyCourse'
  }
  if (navigationTabOrPrefix === 'favorites' || navigationTabOrPrefix === 'Favorites') {
    return 'FavoritesStudyCourse'
  }
  return 'StudyCourse'
}

/** Nested routes under /study/{section}/:userCourseId */
export function createStudyCourseUserRoutes(prefix = '') {
  const n = (name) => (prefix ? `${prefix}${name}` : name)
  const meta = prefix ? { studyContextPrefix: prefix } : {}

  return {
    path: ':userCourseId',
    meta,
    children: [
      {
        path: '',
        name: n('StudyCourse'),
        component: () => import('@/views/study/StudyCourse.vue'),
        meta: { ...meta, returnName: 'BrowsingUserView' },
        props: true,
      },
      {
        path: '',
        name: n('CourseReview'),
        component: () => import('@/views/study/reviews/StudyCourseReview.vue'),
        props: true,
        meta: { ...meta, layout: 'EmptyLayout' },
      },
      {
        path: 'module',
        children: [
          {
            path: ':moduleId',
            children: [
              {
                path: '',
                name: n('StudyModule'),
                component: () => import('@/views/study/StudyModule.vue'),
                props: true,
                meta,
              },
              {
                path: 'lesson',
                children: [
                  {
                    path: ':lessonId',
                    children: [
                      {
                        path: '',
                        name: n('StudyModuleLesson'),
                        component: () => import('@/views/study/StudyLesson.vue'),
                        props: true,
                        meta,
                      },
                      {
                        path: 'test/:testId',
                        name: n('StudyModuleTest'),
                        component: () => import('@/views/study/StudyTest.vue'),
                        props: true,
                        meta,
                      },
                    ],
                  },
                ],
              },
              {
                path: 'review',
                name: n('StudyModuleReview'),
                component: () => import('@/views/study/reviews/StudyModuleReview.vue'),
                props: true,
                meta,
              },
              {
                path: 'questions',
                name: n('StudyModuleQuestions'),
                component: () => import('@/views/study/StudyCourseQuestions.vue'),
                props: true,
                meta,
              },
            ],
          },
        ],
      },
      {
        path: 'lesson',
        children: [
          {
            path: ':lessonId',
            children: [
              {
                path: '',
                name: n('StudyCourseLesson'),
                component: () => import('@/views/study/StudyLesson.vue'),
                props: true,
                meta,
              },
              {
                path: 'test/:testId',
                name: n('StudyCourseTest'),
                component: () => import('@/views/study/StudyTest.vue'),
                props: true,
                meta,
              },
            ],
          },
        ],
      },
      {
        path: 'review',
        name: n('StudyCourseReview'),
        component: () => import('@/views/study/reviews/StudyCourseReview.vue'),
        props: true,
        meta,
      },
      {
        path: 'questions',
        name: n('StudyCourseQuestions'),
        component: () => import('@/views/study/StudyCourseQuestions.vue'),
        props: true,
        meta,
      },
    ],
  }
}
